import React from 'react';
import { Stack } from '@mui/material';
import MaterialTypography from '../../../../components/MaterialTypography';
import MaterialInput from '../../../../components/MaterialInput';
import MaterialBox from '../../../../components/MaterialBox';
import './ReportTable.css';

const TestCoverageSummary = ({ formData, handleTableRemarkChange }) => {
    const renderTable = (title, data, type) => (
        <Stack spacing={2} mb={4}>
            <MaterialTypography variant="h6" fontWeight="bold" color="text">
                {title}
            </MaterialTypography>
            <div className="report-table-container">
                <table className="report-table">
                    <thead>
                        <tr>
                            <th>Test Type</th>
                            <th>Total</th>
                            <th>Passed</th>
                            <th>Failed</th>
                            <th className="remarks-cell">Remarks</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, index) => (
                            <tr key={index}>
                                <td>{row.testType}</td>
                                <td>{row.total}</td>
                                <td>{row.passed}</td>
                                <td>{row.failed}</td>
                                <td className="remarks-cell">
                                    <MaterialInput
                                        size="small"
                                        value={row.remarks}
                                        placeholder="Enter remarks"
                                        onChange={(e) => handleTableRemarkChange(type, index, e.target.value)}
                                        fullWidth
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Stack>
    );

    return (
        <MaterialBox>
            {renderTable('Web Application – Admin & User Portal', formData.webCoverage, 'webCoverage')}
            {renderTable('Mobile Application', formData.mobileCoverage, 'mobileCoverage')}
        </MaterialBox>
    );
};

export default TestCoverageSummary;
